export default {"src":"/_next/static/media/phone.b05c8654.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};